<script setup lang="ts" name="UsersListPendingUsers">
import BaseCollapsible from '~/components/BaseCollapsible.vue';
import UserListPendingRequestsHeader from '~/components/UserListPendingRequestsHeader.vue';
import UserListPendingUser from '~/components/UserListPendingUser.vue';

import type { IAdminUserListPendingUser } from '~/types';

const { users, open } = defineProps<{
  users: IAdminUserListPendingUser[];
  open: boolean;
}>();
</script>

<template>
  <div
    data-test="pending-requests"
    class="rounded border border-primary-4 bg-white shadow"
  >
    <BaseCollapsible :open-by-default="open">
      <template #trigger="{ toggle, isOpen }">
        <UserListPendingRequestsHeader
          class="p-6"
          :open="isOpen"
          :requests="users.length"
          @toggle="toggle"
        />
      </template>

      <template #default="{ toggle }">
        <button
          class="w-full px-6 pb-4 pt-2 text-left text-body-1"
          @click="toggle"
        >
          Review and resolve pending requests from public MyG2 users
        </button>

        <div
          data-test="pending-user-requests"
          class="divide-y divide-charcoal-2 border-t border-charcoal-2"
        >
          <UserListPendingUser
            v-for="user in users"
            :key="user.id"
            :user="user"
          />
        </div>
      </template>
    </BaseCollapsible>
  </div>
</template>
